module.exports = require("./es-PY.d.ts");